import { render, staticRenderFns } from "./back-stock-batch-h5.vue?vue&type=template&id=6f01bf42&scoped=true"
import script from "./back-stock-batch-h5.vue?vue&type=script&lang=js"
export * from "./back-stock-batch-h5.vue?vue&type=script&lang=js"
import style0 from "./back-stock-batch-h5.vue?vue&type=style&index=0&id=6f01bf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01bf42",
  null
  
)

export default component.exports